<template>
  <div class="electron-technology">
    <s-r-m-header ref="header" />
    <IndustryDesc ref="industryDesc" :industryInfo="industryInfo" show-menu title-up />
    <ProjectDesc
      :descInfo="{
        title: '医疗器械行业研发现状',
        description: '璞华易研PLM提供适用于医疗器械行业的研发管理解决方案',
        redContent: '我国医疗器械行业',
        content: ' 21 世纪以来飞速发展，逐渐由最初以生产加工为主的工厂型向更加全面的、技术含量更高的制造业转变。医疗器械行业对产品安全性和有效性要求特别高，因此对产品的设计、生产过程要求尤其严格。 医疗器械制造商的竞争日趋激烈，使得企业在产品管理方面迫切需要通过一种更为系统化、更为全面、更高效的产品生命周期管理广法以及对应的管理平台来迎接这些新挑战。璞华易研PLM系统帮助医疗器械企业全面管理产品生命周期，提升企业的研发管理水平。'
      }"
    ></ProjectDesc>
    <ProblemSolving
      :isPercentage="false"
      :textList="textList"
    ></ProblemSolving>


    
    <LifeCycle 
      title="医疗器械的产品生命周期管理(PLM)"
      description="璞华易研PLM帮助医疗企业构建完整的研发体系平台"
      :listData="listData"
    ></LifeCycle>

    <!-- <product-features
      title="产品功能"
      description="PLM产品生命周期管理产品数据管理、项目协同管理、研发管理、设计工具集成"
      :tabList="tabList"
    ></product-features> -->
    <CompanyInfo
      :projectInfo="projectInfo"
    ></CompanyInfo>

    <ResultsOperation
      :descInfo="{
        title: '运营效果',
        descArr1: [
          '依托项目管理平台，优化、规范企业标准，减少错误',
          '实现企业CSV认证，提高数据的合规性、高效性',
          '实现知识共享，提高研发、项目管理水平',
        ],
        descArr2: [
          '产品的DHF和DMR等文件与产品进行关联，可从本地或者通过模板进行新增，完成产品文件的管理。',
          '打通各系统之间信息孤岛，连通企业各系统，使业务数据有效流动',
        ]
      }"
    ></ResultsOperation>

    <!-- 打通各系统之间信息孤岛，连通企业各系统，使业务数据有效流动
实现知识共享，提高研发、项目管理水平
产品的DHF和DMR等文件与产品进行关联，可从本地或者通过模板进行新增，完成产品文件的管理。
实现企业CSV认证，提高数据的合规性、高效性 -->


    <ChooseUs :nameVals="['MedicalEquipment']" :scrollNum="2"></ChooseUs>
    <custom-form ref="customForm" />
    <footer-box /> 
  </div>
</template>

<script>
import SRMHeader from "@/components/SRMHeader/index";
import IndustryDesc from "@/components/IndustryDesc"
import ProjectDesc from "@/components/ProjectDesc"
import ProblemSolving from "@/components/ProblemSolving"
import LifeCycle from "@/components/LifeCycle"
import AppBenefits from "@/components/AppBenefits"
import ProductFeatures from "@/components/ProductFeatures"
import CompanyInfo from "@/components/CompanyInfo"
import ResultsOperation from "@/components/ResultsOperation"
import ChooseUs from "@/components/ChooseUs"
import CustomForm from "@/components/Form"
import FooterBox from "@/components/FooterBox"
import { baiduConsult } from "./common.js";

import hy2 from '@/assets/images/hy2.png'

export default {
  components: {
    SRMHeader,
    IndustryDesc,
    ProjectDesc,
    ProblemSolving,
    LifeCycle,

    AppBenefits,
    ProductFeatures,
    CompanyInfo,
    ResultsOperation,
    ChooseUs,
    CustomForm,
    FooterBox,
  },
  metaInfo() {
    return {
      title: '璞华易研 - 企业级PLM&PMS解决方案',
      meta: [
        {
          name: 'keywords',
          content: '璞华易研,PLM,PMS,PDM,产品生命周期管理,研发项目管理,国产PLM,智能制造'
        },
        {
          name: 'description',
          content: '璞华官方热线：4006-160-730。璞华易研PLM&PMS，帮助客户高效实现产品生命周期管理和研发项目管理，在流程行业、医疗器械、芯片半导体、电子高科技、机械制造等方面拥有丰富的案例。'
        }
      ]
    }
  },
  data() {
    return {
      textList:  [
        {
          name: '项目',
          list: ['建立符合医疗设备行业QMS体系的产品开发项目管理体系，对设备研发过程、资源、交付物及过程质量进行管理']
        },
        {
          name: '质量',
          list: ['建立产品全过程闭环质量管理体系，对研发过程质量、缺陷、生产过程质量、客户投诉等进行统一管理']
        },
        {
          name: '数据文档',
          list: ['建立符合医疗设备行业QMS体系的合规数据集（含DHF、DMR、R/A docs、Risk Management、Change Managemgmt 、CAPA）']
        },
        {},
        {
          name: '工作流',
          list: ['建立协同的技术评审及产品资料电子化审签流程，对资料的创建、审批及发布进行管理']
        },
      ],

      listData: [
        {
          num: '01',
          description: '建立符合医疗设备行业QMS体系的合规数据集（含DHF、DMR、R/A docs、Risk Management、Change Managemgmt 、CAPA',
        },
        {
          num: '02',
          description: '建立符合医疗设备行业QMS体系的产品开发项目管理体系，对设备研发过程、资源、交付物及过程质量进行管理',
        },
        {
          num: '03',
          description: '建立协同的技术评审及产品资料电子化审签流程，对资料的创建、审批及发布进行管理',
        },
        {
          num: '04',
          description: '建立产品全过程闭环质量管理体系，对研发过程质量、缺陷、生产过程质量、客户投诉等进行统一管理',
        }
      ],
      industryInfo: {
        bg: hy2,
        text2: '璞华易研PLM研发平台帮助医疗器械行业实现业务环节数据打通',
        text3: '共享完整的研发信息，提升各阶段的研发任务效率'
      },
      projectInfo: {
        companyName: '典型案例',
        subTitle: '乐普(北京)医疗器械股份有限公司',
        description: '公司拥有多种技术特点的冠脉药物支架、球囊、起搏器、封堵器、心脏瓣膜、血管造影机、IVD设备及诊断试剂、外科器械、人工智能心电设备和家用智能医疗器械等',
        paragraph: [
          '乐普专注于提供用于检测、诊断或监测疾病、健康状况或生理状态的医疗设备和试剂。医疗器械IVD行业行业对产品的质量和可靠性要求极高，同时还需要满足严格的法规和合规性要求。',
          'PLM系统的需求背景主要体现在产品开发、法规遵从、版本控制和质量管理等方面。通过PLM系统的应用，可以更加高效地管理产品的全生命周期，提高产品的质量和市场竞争力。',
          // 'PLM系统能够帮助企业实现法规遵从，确保产品在设计、生产和销售过程中符合相关法规的要求。通过PLM系统的合规性管理功能，企业可以及时了解并应对法规变化，降低合规风险。',
          // 'PLM系统能够提供强大的版本控制和变更管理功能，帮助企业更好地管理产品的升级和变更。通过PLM系统，企业可以清晰地跟踪产品的历史记录，确保每一次变更都得到了有效的管理和控制。',
          // 'PLM系统能够提供质量管理和追溯功能，帮助企业实现对产品质量的全面监控。通过PLM系统，企业可以及时发现并解决质量问题，确保产品的稳定性和可靠性。'
        ],
        caseList: [
          {
            num: '01',
            title: '流程管理',
            contentList: [
            '搭建符合企业DHF/DMR流程体系',
            'EC全流程管控机制，易于数据追溯',
            '建立企业无纸化业务办公平台',
            '企业流程的标准化，统一分配、执行、查阅',
            '固化开发流程，控制关键节点必须执行'
            ]
          },
          {
            num: '02',
            title: '数据管理',
            contentList: [
              '构建清晰完整的产品谱系',
              '实现物料、文件过程数据的编码管理机制',
              '打通企业信息孤岛，实现研发数据智能化流转',
              '产品协同提高研发效率，提高数据衍生管理',
              '建立企业模型化数据，实现数智化研发'
            ]
          },
          {
            num: '03',
            title: '项目管理',
            contentList: [
              '实现过程文件DHF/DMR文件的体系化管理过程',
              '规范产品开发流程、过程数据可记录、可追溯、强化管理能力',
              '建立符合企业QMS体系管理模式，提高研发项目数据的准确合规性',
              '图形化报表实时展现企业研发进度'
            ]
          }
        ]
      },
      tabList: [
        {
          name: 'first',
          label: '数据管理',
          title: '以数据为核心',
          otherTitle: '将数据管理贯穿产品的全生命周期',
          effectDrawing: require('@/assets/images/gn1.png'),
          contentList: [
            {
              title: '物料管理',
              content: '物料编码规则、物料属性定义、物料的生命周期管理、物料分类定义'
            },
            {
              title: 'bom管理',
              content: 'bom结构、替代料管理、bom正反结构查询'
            },
            {
              title: '制造商管理',
              content: '制造商管理、制造商部件号管理'
            },
            {
              title: '文档管理',
              content: '文档分类、文档版本、文档权限等管理'
            }
          ]
        },
        {
          name: 'second',
          label: '变更管理',
          title: '根据用户的个性化需求，支持用户定义各种规则，对变更进行',
          otherTitle: '跟踪和管理',
          effectDrawing: require('@/assets/images/gn2.png'),
          contentList: [
            {
              content: '内置了行业标准的ECR-ECO的工程变更解决方案'
            },
            {
              content: '可以根据客户的个性化需求进行业务流程配置'
            },
            {
              content: '提供了行业领先的用户可编程引擎，支持用户定义各种规则'
            }
          ]
        },
        {
          name: 'third',
          label: '项目管理',
          title: '项目计划＆项目进度＆项目交付＆项目报表',
          effectDrawing: require('@/assets/images/gn3.png'),
          contentList: [
            {
              content: '采用最新的BS技术实现项目中的各种管理功能'
            },
            {
              content: '包含项目计划、交付、资源、工时、费用、报表等核心功能'
            },
            {
              content: '帮助企业实现项目集的管理，规范项目数据，缩短研发周期'
            }
          ]
        },
        {
          name: 'four',
          label: '数据建模',
          title: '通过数据建模，支持客户的个性化需求',
          effectDrawing: require('@/assets/images/gn4.png'),
          contentList: [
            {
              content: '提供强大的配置平台，支持根据客户的个性化需求配置基础设置、对象分类、对象属性、工作流程、权限'
            },
            {
              content: '实现完全可配置的业务，支持数据、流程、字段级别的数据建模和精细化的权限控制'
            }
          ]
        },
        {
          name: 'five',
          label: '在线可视化',
          title: '目前支持超过40多种主流的文件格式在线预览，所见即所得',
          effectDrawing: require('@/assets/images/gn5.png'),
          contentList: [
            {
              content: '采用最新的BS架构实现了文件的预览，不需要用户客户端安装任何的客户端软件'
            },
            {
              content: '支持主流2D文件(Office、CAD、压缩文件、文本文件、图片、音频)格式的预览'
            },
            {
              content: '支持主流3D文件(prt、asm、pcb、stp) 格式的预览'
            }
          ]
        },
        {
          name: 'six',
          label: '第三方接入',
          title: '轻松实现与第三方软件的对接',
          effectDrawing: require('@/assets/images/gn6.png'),
          contentList: [
            {
              content: '通过标准的API接口和Webservice接口，实现PLM的数据同企业的其他业务系统和移动办公系统的深度集成'
            },
            {
              content: '自带主流的ERP集成接口和移动端集成，支持数据导出'
            }
          ]

        }
      ]
    }
  },
  mounted() {
    baiduConsult();
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/mixins.scss";

.electron-technology {
  ::v-deep .project-desc {
    .project-content {
      width: 140rem;
    }
  }
  ::v-deep .industry-desc {
    .text-content {
      padding-top: 16.8rem;
      .text2,.text3 {
        line-height: 7.2rem;
      }
    }
  }
  ::v-deep .systemFunction-container {
    background: linear-gradient( 168deg, #FBFCFD 0%, #F4F7F9 100%);
  }
  ::v-deep .point-of-pain {
    .point-of-pain-title {
      padding: 10rem 0 2.4rem !important;
    }
    .point-of-pain-description {
      padding-bottom: 6.2rem !important;
    }
    .list-item {
      padding: 5.6rem 5.2rem 0rem 4.8rem !important;
      height: 24.6rem !important;
      .cl-list {
        margin-top: 3rem !important;
      }
      .cl-l-i-content {
        padding-left: 0 !important;
        &::before {
          border: none !important;
        }
      }
    }
  }
  .typical-user {
    ::v-deep .systemFunction-list {
      height: 55.2rem;
    }
  }
  ::v-deep .productfeature {
    .content-left {
      padding: 0;
      left: 26rem;
      width: 54rem;
    }
    .content-right {
      width: 88.2rem;
      height: 51rem;
      top: 12.7rem;
      right: 17.1rem;
    }
  }

  @include mobile-page-overrides;
}
</style>
